import { ErrorEnum, Path } from '@authority-labs/enums';

export const translationsHE = {
  yes: 'כן',
  no: 'לא',
  add: 'הוסף',
  id: "מס'",
  createdAt: 'תאריך הקמה',
  createdAtShort: 'ת.הקמה',
  updatedAt: 'תאריך עדכון',
  deletedAt: 'תאריך מחיקה',
  updatedBy: 'עודכן ע"י',
  createdBy: 'הוקם ע"י',
  name: 'שם',
  projectName: 'שם הפרוייקט',
  street: 'רחוב',
  buildingNumber: "מס' בית",
  block: 'גוש',
  plot: 'חלקה',
  lot: 'מגרש',
  units: "מס' יחידות",
  buildingArea: 'שטח המבנה',
  buildingParts: 'חלקי המבנה',
  subProjects: 'הסכמים',
  projectSubProjects: 'הסכמים',
  orders: 'הזמנות',
  subProjectOrders: 'הזמנות',
  order: 'הזמנה',
  notes: 'הערות',
  note: 'הערה',
  lastNote: 'הערה אחרונה',
  projectId: "מס' פרוייקט",
  projectCost: 'עלות',
  cost: 'עלות',
  parentSubProjectId: 'מספר הסכם מקורי',
  relatedToSubProjectId: "קשור להסכם מס'",
  assignee: 'שם הבודק',
  approvedBy: 'שם המאשר',
  reviewedBy: 'שם הבודק השני',
  isApproved: 'התעודה אושרה',
  fieldType: 'תחום',
  procurementNumber: "מס' הזמנת רכש",
  conclusion: 'מסקנה',
  relatedToOrderId: "קשורה להזמנה מס'",
  orderCost: 'עלות הזמנה',
  subProjectCost: 'עלות',
  subProjectUsedMoney: 'נוצל',
  subProjectLeftMoney: 'יתרה',
  inspectionTypes: 'סוג בדיקה',
  inspectionType: 'סוג בדיקה',
  orderDirectories: 'קבצים',
  subProjectId: "מס' הסכם",
  address: 'כתובת',
  companyNumber: 'ח.פ.',
  paymentTerms: 'תנאי תשלום',
  contacts: 'אנשי קשר',
  email: 'דואר אלקטרוני',
  extraEmail: 'דואר אלקטרוני נוסף',
  emailShort: 'אמייל',
  displayName: 'שם',
  role: 'רמה',
  isDisabled: 'סטטוס',
  avatar: 'תמונה',
  totalCost: 'סה"כ לתשלום',
  vat: 'מע"מ',
  totaltCostIncludingVat: 'סה"כ כולל מע"מ',
  mobileNumber: "מס' טלפון נייד",
  phoneNumber: "מס' טלפון נייח",
  phone: "מס' טלפון",
  extraPhone: "מס' טלפון נוסף",
  phoneShort: 'טלפון',
  jobTitle: 'תפקיד',
  companyId: `מס' חברה`,
  companyName: 'חברה',
  staff: 'אנשי מקצוע',
  settings: 'הגדרות',
  cancel: 'ביטול',
  officeName: 'שם המשרד',
  subProjectDetails: 'פרטי ההסכם',
  orderDetails: 'פרטי ההזמנה',
  bid: 'הצעת מחיר',
  actions: 'פעולות',
  companyStatus: 'סטטוס',
  companyType: 'מחירון מתזים',
  detectionPriceList: 'מחירון גילוי',
  bidApprovalType: 'אופן אישור הצעת מחיר',
  selectOrder: 'בחר',
  isActive: 'פעיל',
  isPrivate: 'פרטי',
  date: 'תאריך',
  recipientName: 'מטופל ע"י',
  inspectionDate: 'תאריך הבדיקה',
  statusUpdatedAt: 'תאריך עדכון סטטוס',
  orderStatus: 'סטטוס הזמנה',
  orderEmpty: 'אין שינויים בהזמנות',
  extendSubProject: 'הרחבת הסכם',
  signature: 'חתימה',
  signatureName: 'שם לתעודה',
  subProjectNotes: 'הערות להצעת מחיר',
  chosenVersion: 'הצעת מחיר מאושרת',
  companyStatuses: 'סטטוסים חברה משלמת',
  orderStatuses: 'סטטוסים של הזמנה',
  aiSettings: {
    title: 'הגדרות בינה מלאכותית',
    intro:
      'בחירת ספק ומודל לכל יכולת, ספי ביטחון, תקרת עלות יומית, תיבות דואר מנוטרות וכללי ניתוב. מפתחות ה-API נשמרים בסביבת השרת בלבד.',
    tabs: {
      models: 'ספקים ומודלים',
      triage: 'ניתוב מיילים',
      mailboxes: 'תיבות דואר',
      rules: 'כללי ניתוב',
      connectors: "חיבור צ'אט"
    },
    modeHint:
      'ההחלטות והקטגוריות נרשמות ביומן ההחלטות. Outlook משתנה רק כשהמתג "קטגוריות ב-Outlook" (בלשונית קטגוריות) מופעל.',
    outlookCategories: {
      title: 'קטגוריות',
      intro:
        'הקטגוריות ש-LCL מסמן על מיילים בתיבת office@: לכל מחלקה, למיילים שדורשים בדיקה ידנית, או לתגית נושא. הוספה או הסרה כאן לא יוצרת ולא מוחקת קטגוריה ב-Outlook: יוצרים אותה שם ידנית, באותו שם בדיוק.',
      outlook: 'קטגוריות ב-Outlook',
      offHint:
        'כבוי: הקטגוריות נשמרות רק בעותק של המייל ב-LCL. שום דבר לא משתנה ב-Outlook.',
      onHint:
        'מופעל: LCL מוסיף את הקטגוריות גם למייל בתיבת office@, כולל החלטות מ-7 הימים האחרונים. LCL מסיר רק קטגוריה שהוא עצמו הוסיף; קטגוריות שאנשים הוסיפו נשארות. LCL לא מוחק ולא מזיז מיילים.',
      add: 'הוספת קטגוריה',
      name: 'שם הקטגוריה',
      nameHint: 'בדיוק כמו ב-Outlook: Outlook מזהה קטגוריה לפי השם.',
      appliesTo: 'מתי מסומנת',
      enabled: 'פעילה',
      removeConfirm:
        'להסיר את הקטגוריה? מיילים שכבר מסומנים בה נשארים כך, והיא לא נמחקת מ-Outlook.',
      uncovered: 'למחלקות האלה אין קטגוריה פעילה: {{names}}',
      departmentGone: 'מחלקה שנמחקה',
      kinds: {
        department: 'מחלקה',
        review: 'בדיקה ידנית',
        tag: 'תגית נושא'
      },
      kindHints: {
        department: 'מייל שהמחלקה שלו נקבעה (בביטחון מספיק, או בתיקון ידני).',
        review: 'מייל שה-AI לא בטוח לגביו או שאדם צריך להחליט עליו.',
        tag: 'מייל שקיבל את תגית הנושא הזו, בנוסף לקטגוריית המחלקה.'
      },
      errors: {
        name: 'יש להזין שם',
        department: 'יש לבחור מחלקה',
        tag: 'יש לבחור תגית'
      }
    },
    topicTags: 'תגיות נושא',
    topicTagsHint:
      'ה-AI מסמן כל מייל ב-1 עד 3 תגיות מהרשימה, כדי שיהיה ברור במבט אחד במה הוא עוסק.',
    departments: {
      title: 'מחלקות',
      intro:
        'כל מייל ב-office@ משויך למחלקה אחת. ענף מזוהה לפי סוגי הבדיקות של ההזמנה או ההצעה שהמייל מזכיר, ולפי מילות מפתח. מחלקת המשרד מקבלת דואר כללי.',
      add: 'הוספת מחלקה',
      edit: 'עריכה',
      view: 'צפייה',
      disabled: 'מושבתת',
      none: 'אין',
      noMembers: 'טרם הוגדרו',
      inspectionTypes: 'סוגי בדיקות',
      typesCount: '{{count}} סוגי בדיקות',
      typesHint:
        'סוג שכבר משויך לענף אחר מופיע עם שם הענף. מומלץ שכל סוג יהיה בענף אחד.',
      more: 'ועוד {{count}}',
      keywords: 'מילות מפתח',
      members: 'עובדים',
      membersHint:
        'עובדי המחלקה יסומנו כמטפלים ויקבלו התראות. העברות עבר אליהם מלמדות את ה-AI איזו מחלקה טיפלה בכל מייל.',
      name: 'שם',
      key: 'מזהה',
      keyHint: 'אותיות לטיניות קטנות, ספרות ומקף. ה-AI עונה עם המזהה הזה.',
      kind: 'סוג',
      kinds: {
        branch: 'ענף',
        office: 'משרד (דואר כללי)'
      },
      description: 'במה המחלקה מטפלת',
      descriptionHint: 'שורה לכל נושא. ה-AI קורא את הטקסט הזה כשהוא מחליט.',
      folder: 'תיקייה ב-Outlook',
      enabled: 'פעילה',
      cancel: 'ביטול',
      unmapped:
        'סוגי בדיקות שלא שויכו לאף ענף. מיילים על הזמנות כאלה לא ישויכו לענף לפי הרשומה:',
      loadFailed: 'טעינת המחלקות נכשלה',
      errors: {
        name: 'חסר שם',
        key: 'מזהה לא תקין'
      }
    },
    connectors: {
      toolNames: {
        describe_lcl: 'מה יש ב-LCL',
        list_statuses: 'סטטוסים',
        search_orders: 'חיפוש הזמנות',
        get_order: 'פרטי הזמנה',
        list_order_files: 'קבצי הזמנה',
        order_stats: 'סטטיסטיקת הזמנות',
        search_subprojects: 'חיפוש הסכמים',
        get_subproject: 'פרטי הסכם',
        list_subproject_files: 'קבצי הסכם',
        search_projects: 'חיפוש פרויקטים',
        get_project: 'פרטי פרויקט',
        search_companies: 'חיפוש חברות',
        get_company: 'פרטי חברה',
        search_contacts: 'חיפוש אנשי קשר',
        search_planners: 'חיפוש מתכננים',
        search_contractors: 'חיפוש קבלנים',
        search_inspections: 'חיפוש בדיקות',
        get_inspection: 'פרטי בדיקה',
        get_inspection_checklist: "צ'קליסט בדיקה",
        list_users: 'צוות LCL',
        search_emails: 'חיפוש מיילים של המשרד',
        get_email: 'מייל מלא',
        get_record_history: 'היסטוריית שינויים',
        recent_activity: 'פעילות אחרונה',
        login_activity: 'כניסות למערכת',
        search: 'חיפוש ב-LCL',
        fetch: 'שליפת רשומה'
      },
      title: 'חיבור Claude / ChatGPT לנתוני LCL',
      intro:
        "כל משתמש עם הרשאת חיבור יכול לחבר את הצ'אט שלו ל-LCL ולשאול שאלות על הזמנות, הסכמים, פרוייקטים וחברות. הצ'אט רואה רק מה שהמשתמש עצמו רשאי לראות (כולל מחירים), לקריאה בלבד, וכל קריאה נרשמת.",
      serverUrl: 'כתובת שרת ה-MCP',
      copy: 'העתקה',
      copied: 'הכתובת הועתקה',
      enabled: 'החיבור פעיל',
      enabledHint: 'כיבוי חוסם מיד את כל החיבורים הקיימים',
      dcr: 'אפשר רישום אוטומטי של לקוחות (DCR)',
      dcrHint:
        'נדרש עבור MCP Inspector ולקוחות ישנים; Claude ו-ChatGPT משתמשים ב-CIMD גם בלעדיו',
      rateLimit: 'מקסימום קריאות לדקה למשתמש',
      howTo: 'איך מחברים',
      howToClaude:
        'Claude: הגדרות > Connectors > Add custom connector, הדביקו את כתובת השרת ואשרו בדף שייפתח ב-LCL.',
      howToChatGpt:
        'ChatGPT (Business/Enterprise): Settings > Connectors > Create (Developer mode), הדביקו את כתובת השרת ואשרו ב-LCL.',
      myTools: "מה הצ'אט שלכם יוכל לשאול",
      connections: 'חיבורים פעילים',
      allConnections: 'כל המשתמשים',
      user: 'משתמש',
      client: 'לקוח',
      connectedAt: 'חובר',
      lastUsed: 'שימוש אחרון',
      expires: 'תוקף',
      revoke: 'ניתוק',
      revokeConfirm: 'לנתק את החיבור הזה?',
      revoked: 'החיבור נותק',
      revokeFailed: 'הפעולה נכשלה',
      noConnections: 'אין חיבורים פעילים',
      never: 'מעולם לא',
      disabledAlert:
        "החיבור כבוי: לקוחות צ'אט לא יכולים להתחבר ולקרוא נתונים כרגע.",
      infoFailed: 'טעינת פרטי השרת נכשלה. רעננו את הדף ונסו שוב.',
      copyFailed: 'ההעתקה נכשלה. סמנו את הכתובת והעתיקו ידנית.',
      myConnections: 'החיבורים שלי',
      myConnectionsIntro:
        "לקוחות הצ'אט שחיברתם לנתוני LCL. ניתוק מסיים את החיבור מיד; אפשר לחבר מחדש מהצ'אט בכל עת.",
      dcrBadge: 'רישום עצמי'
    },
    features: {
      triage: 'סיווג וניתוב מיילים',
      drafting: 'ניסוח טיוטות',
      chat: "צ'אט על נתוני LCL"
    },
    provider: 'ספק',
    model: 'מודל',
    notConfigured: 'לא מוגדר (חסרים פרטי גישה בסביבת השרת)',
    modelIssue: {
      provider: 'חסר מפתח לספק הזה בשרת',
      deployment: 'אין Deployment למודל הזה: הוסיפו אותו במיפוי למטה',
      unknown: 'המודל לא מוכר: בחרו מודל מהרשימה'
    },
    pricing: 'תמחור (דולר למיליון טוקנים)',
    input: 'קלט',
    output: 'פלט',
    cacheRead: 'קריאה מקאש',
    testConnection: 'בדיקת חיבור',
    testOk: 'החיבור תקין',
    testFailed: 'החיבור נכשל',
    azureDeployments: 'מיפוי מודל ← שם Deployment ב-Azure',
    azureApiVersion: 'גרסת API של Azure OpenAI',
    deploymentName: 'שם Deployment',
    dailyCap: 'תקרת עלות יומית (דולר)',
    mode: 'מצב פעולה',
    modes: {
      off: 'כבוי',
      shadow: 'צל (החלטות נרשמות ב-LCL)',
      drafts: 'טיוטות (נוצרות בתיקיית הטיוטות)'
    },
    threshold: 'סף ביטחון להחלטה',
    maxDrafts: 'מקסימום טיוטות ביום',
    retention: 'שמירת תוכן מיילים (ימים)',
    aliases: 'כתובות חלופיות ← משתמש נוכחי',
    aliasFrom: 'כתובת ישנה / חלופית',
    aliasTo: 'כתובת המשתמש הנוכחי',
    add: 'הוספה',
    edit: 'עריכה',
    remove: 'הסרה',
    addAlias: 'הוספת כתובת',
    saveAllHint: 'השמירה חלה על כל ההגדרות בלשונית.',
    save: 'שמירה',
    saved: 'ההגדרות נשמרו',
    saveFailed: 'השמירה נכשלה',
    loadFailed: 'טעינת ההגדרות נכשלה',
    capability: 'יכולת',
    providerNotConfigured: '(לא מוגדר)',
    azureOpenAi: 'Azure OpenAI',
    resetPrice: 'ברירת מחדל',
    invalidEmail: 'יש להזין כתובת אימייל תקינה',
    mailbox: {
      pollingOnly: 'בדיקה כל 5 דקות',
      monthsBack: 'חודשים אחורה',
      address: 'כתובת תיבה',
      kind: 'סוג',
      kinds: { office: 'משרד', user: 'משתמש' },
      user: 'משתמש LCL',
      enabled: 'פעיל',
      lastSync: 'סנכרון אחרון',
      subscription: 'מנוי התראות',
      subscriptionUntil: 'עד',
      none: 'אין',
      history: 'ייבוא היסטוריה',
      importHistory: 'ייבוא היסטוריית העברות',
      months: 'חודשים אחורה',
      importQueued: 'ממתין בתור לייבוא',
      importRunning: 'הייבוא רץ…',
      importDone: 'הייבוא הסתיים',
      importForwards: 'העברות',
      importExamples: 'דוגמאות',
      importLinked: 'קושרו',
      importNegatives: 'ללא פעולה',
      importUnmapped: 'לא זוהו',
      importFailed: 'הייבוא נכשל',
      syncNow: 'סנכרון עכשיו',
      syncStarted: 'סנכרון הופעל',
      syncFailed: 'הסנכרון נכשל',
      loadFailed: 'הטעינה נכשלה',
      saved: 'נשמר',
      failed: 'הפעולה נכשלה',
      empty: 'אין תיבות מנוטרות. הוסיפו את תיבת המשרד כדי להתחיל.',
      add: 'הוספת תיבה',
      edit: 'עריכת תיבה',
      delete: 'מחיקה',
      deleteConfirm: 'למחוק את התיבה המנוטרת?'
    },
    replies: {
      intro:
        'LCL כותב טיוטת תשובה למיילים מבחוץ שמגיעים לתיבה האישית של עובד, על סמך המייל, הנתונים ב-LCL ומיילים קודמים. הטיוטה נשמרת בתיקיית הטיוטות של העובד בלבד ולא נשלחת. התוכן של תיבה אישית לא מוצג בשום מסך ב-LCL.',
      draftingUnavailable:
        'מודל הניסוח שנבחר לא מוגדר בשרת, ולכן טיוטות ותיאורי סגנון לא נכתבים. בחרו מודל זמין לניסוח טיוטות בניהול מערכת ← ספקים ומודלים.',
      globalMode: 'מתג כללי',
      globalHint:
        'המתג הכללי גובר על המצב של כל תיבה: "כבוי" עוצר את כולן, ו"צל" לא יוצר טיוטות ב-Outlook גם בתיבה שמוגדרת לטיוטות.',
      modes: {
        off: 'כבוי',
        shadow: 'צל (טיוטות נשמרות ב-LCL בלבד)',
        drafts: 'טיוטות ב-Outlook'
      },
      short: { off: 'כבוי', shadow: 'צל', drafts: 'טיוטות' },
      mailboxes: 'תיבות אישיות',
      owner: 'עובד',
      ownerPick: 'בחירת עובד',
      ownerHint: 'תיבה אישית היא תמיד הכתובת של העובד עצמו.',
      mailboxMode: 'מצב התיבה',
      historyMonths: 'ייבוא היסטוריה (חודשים אחורה)',
      retentionDays: 'שמירת מיילים אישיים (ימים)',
      dailyCostCap: 'תקרת עלות יומית לטיוטות ($)',
      dailyCostCapHint:
        'כשהטיוטות מגיעות לתקרה הזו, הן נעצרות עד מחר. 0 = רק התקרה הכללית.',
      historyTooLong:
        'ההיסטוריה ארוכה מתקופת השמירה: הגדילו את ימי השמירה (חודש = 31 יום) או קצרו את ההיסטוריה.',
      retentionHint:
        'מיילים מתיבות אישיות נמחקים מ-LCL אחרי מספר הימים הזה. הסרת תיבה מוחקת מיד את כל המיילים שלה מ-LCL.',
      history: 'היסטוריה',
      style: 'סגנון כתיבה',
      styleTitle: 'סגנון הכתיבה של {{name}}',
      styleIntro:
        'כך העובד כותב, לפי המיילים ששלח. הטיוטות נכתבות בסגנון הזה. אפשר לתקן את הטקסט: תיקון נשמר ולא מתעדכן אוטומטית.',
      styleNone:
        'עוד אין תיאור סגנון. הוא נכתב אחרי ייבוא ההיסטוריה, או בלחיצה על "כתיבה מחדש מהמיילים".',
      styleGenerated:
        'נכתב ב-{{date}} מ-{{count}} מיילים ששלח. מתעדכן פעם בשבוע.',
      styleEdited: 'תוקן על ידי {{by}} ב-{{date}}. לא מתעדכן אוטומטית.',
      styleGenerate: 'כתיבה מחדש מהמיילים',
      close: 'סגירה',
      importButton: 'ייבוא {{months}} חודשים אחרונים',
      importRunning: 'הייבוא רץ… {{sent}} נשלחו, {{inbox}} בתיבה',
      importDone:
        'יובא ב-{{date}}: {{replies}} תשובות ({{paired}} עם המייל שעליו ענו), {{inbound}} מיילים מבחוץ',
      now: 'בפועל',
      capped: 'מוגבל על ידי המתג הכללי',
      add: 'הוספת תיבה אישית',
      empty: 'אין תיבות אישיות. הוסיפו עובד כדי להתחיל.',
      removeConfirm:
        'להסיר את התיבה? LCL יפסיק לקרוא אותה. טיוטות שכבר נוצרו נשארות בתיבה.',
      saved: 'נשמר',
      failed: 'הפעולה נכשלה',
      loadFailed: 'טעינת התיבות נכשלה'
    },
    rule: {
      name: 'שם הכלל',
      priority: 'עדיפות (נמוך = קודם)',
      enabled: 'פעיל',
      isOverride: 'כלל גובר (לפני המודל)',
      fallback: 'כלל גיבוי (כשהמודל לא בטוח)',
      action: 'פעולה',
      actions: {
        route: 'ניתוב למשתמשים',
        skip: 'ללא פעולה',
        'force-human': 'העברה לבדיקה ידנית'
      },
      recipients: 'נמענים',
      department: 'מחלקה',
      match: 'תנאי התאמה (כל התנאים שהוזנו חייבים להתקיים)',
      fromAddress: 'כתובת שולח',
      fromDomain: 'דומיין שולח',
      subjectRegex: 'ביטוי רגולרי על הנושא',
      keywords: 'מילות מפתח (אחת מהן)',
      hasAttachment: 'עם קובץ מצורף',
      any: 'לא משנה',
      yes: 'כן',
      no: 'לא',
      type: 'סוג',
      summary: {
        fromAddress: 'שולח',
        fromDomain: 'דומיין',
        subject: 'נושא',
        keywords: 'מילים',
        withAttachment: 'עם קובץ',
        withoutAttachment: 'בלי קובץ'
      },
      errors: {
        name: 'יש להזין שם',
        match: 'יש להזין לפחות תנאי התאמה אחד',
        regex: 'הביטוי הרגולרי אינו תקין',
        recipients: 'יש לבחור נמענים',
        department: 'יש לבחור מחלקה'
      },
      loadFailed: 'הטעינה נכשלה',
      saved: 'נשמר',
      failed: 'הפעולה נכשלה',
      notes: 'הערות',
      empty: 'אין כללים. המודל מחליט לבד לפי ההיסטוריה.',
      add: 'הוספת כלל',
      edit: 'עריכת כלל',
      delete: 'מחיקה',
      deleteConfirm: 'למחוק את הכלל?'
    }
  },
  superAdmin: {
    title: 'ניהול מערכת',
    groups: {
      ai: 'בינה מלאכותית',
      system: 'מערכת'
    },
    sections: {
      overview: 'סקירה',
      usage: 'שימוש ועלויות',
      models: 'ספקים ומודלים',
      chat: "חיבור צ'אט",
      mailTriage: 'ניתוב מיילים',
      replyDrafts: 'טיוטות תשובה',
      system: 'שרת ואחסון'
    },
    replyDrafts: {
      settings: 'הגדרות ותיבות',
      log: 'יומן טיוטות',
      intro:
        'דף זמני לתקופת הניסיון: מה ה-AI כתב לכל מייל, למה לא נכתבה תשובה, ומה קרה לטיוטה. רק מנהל המערכת רואה אותו.',
      noMailboxes: 'אין תיבות אישיות. הוסיפו תיבה בלשונית ההגדרות.',
      mailbox: 'תיבה',
      refresh: 'רענון',
      syncNow: 'בדיקת מיילים חדשים',
      checkFeedback: 'עדכון תוצאות',
      done: 'בוצע',
      failed: 'הפעולה נכשלה',
      empty: 'אין טיוטות להצגה.',
      received: 'התקבל',
      from: 'מאת',
      subject: 'נושא',
      status: 'מצב',
      outcome: 'תוצאה',
      changed: 'שונה',
      confidence: 'ביטחון',
      avgChanged: 'בממוצע שונה {{percent}}',
      draft: 'טיוטה',
      email: 'המייל',
      aiReply: 'התשובה שה-AI כתב',
      ownReply: 'התשובה שהעובד שלח בפועל',
      reason: 'סיבה',
      builtFrom: 'על מה התשובה מבוססת',
      thread: '{{count}} הודעות קודמות בשרשור',
      examples: '{{count}} תשובות קודמות של העובד למיילים דומים',
      withStyle: 'עם תיאור סגנון הכתיבה',
      withoutStyle: 'בלי תיאור סגנון כתיבה',
      tools: 'בדיקות ב-LCL',
      records: 'רשומות',
      foreignRecords: 'רשומות שאינן של השולח',
      retry: 'כתיבה מחדש',
      retryQueued: 'נשלח לכתיבה מחדש. התוצאה תופיע תוך כדקה.',
      filters: {
        all: 'הכל',
        reply: 'נכתבה תשובה',
        'no-reply': 'אין צורך בתשובה',
        skipped: 'סוננו',
        error: 'שגיאות'
      },
      statuses: {
        skipped: 'סונן',
        'no-reply': 'אין צורך בתשובה',
        shadow: 'ב-LCL בלבד',
        'draft-pending': 'נוצרת ב-Outlook',
        'draft-created': 'טיוטה ב-Outlook',
        writing: 'בכתיבה',
        capped: 'ממתינה למחר (מכסה יומית)',
        error: 'שגיאה'
      },
      outcomes: {
        pending: 'ממתינות',
        'sent-as-is': 'נשלחו כמו שהן',
        'sent-edited': 'נשלחו עם שינויים',
        deleted: 'נמחקו',
        'human-replied': 'העובד ענה בעצמו',
        ignored: 'לא טופלו'
      },
      screens: {
        'auto-reply': 'מענה אוטומטי',
        'no-reply-sender': 'כתובת שלא עונים לה',
        internal: 'מייל פנימי',
        'not-addressed': 'העובד לא בנמענים',
        'cc-only': 'העובד רק בהעתק',
        'suspected-injection': 'חשד להוראות זדוניות במייל',
        'too-old': 'מייל ישן',
        empty: 'מייל ריק',
        'already-replied': 'העובד כבר ענה',
        'owner-inactive': 'המשתמש לא פעיל'
      },
      keptInLcl: {
        'foreign-records': 'נשארה ב-LCL: התשובה מסתמכת על רשומות של חברה אחרת',
        'reply-to': 'נשארה ב-LCL: כתובת התשובה (Reply-To) שונה מהשולח',
        'outside-recipients':
          'נשארה ב-LCL: במייל יש נמענים חיצוניים מדומיין אחר',
        links: 'נשארה ב-LCL: התשובה כוללת קישור או כתובת מייל שלא מופיעים במייל'
      },
      backtest: {
        title: 'בדיקה היסטורית של טיוטות',
        intro:
          'מיילים שהעובד כבר ענה עליהם נכתבים מחדש על ידי ה-AI, וכל טיוטה מושווית לתשובה שנשלחה בפועל. דבר לא נכתב ל-Outlook.',
        days: 'ימים אחורה',
        limit: 'מקסימום מיילים',
        run: 'הרצת בדיקה',
        started: 'הבדיקה החלה. התוצאות יתעדכנו כאן.',
        never: 'טרם הורצה בדיקה לתיבה זו.',
        running: 'הבדיקה רצה: {{done}} מתוך {{total}}',
        model: 'מודל הכתיבה',
        judge: 'מודל השיפוט',
        cards: {
          usable: 'טיוטות שמישות',
          usableAnswerable: 'שמישות מתוך מה שאפשר לענות',
          ownerOnly: '{{count}} דרשו ידע של העובד',
          misleading: 'טיוטות מטעות',
          facts: 'עובדות תואמות',
          invented: 'עובדות מומצאות',
          untraceable: '{{count}} עם מספרים ללא מקור',
          tone: 'סגנון (1–5)',
          complete: 'שלמות (1–5)',
          medianEdit: 'שינוי חציוני',
          toOutlook: 'היו מגיעות ל-Outlook',
          cases: 'מיילים שנבדקו'
        },
        columns: {
          result: 'תוצאה',
          facts: 'עובדות',
          usable: 'שמישות'
        },
        results: {
          judged: 'נבדקה',
          unjudged: 'ללא שופט',
          'no-reply': 'ה-AI לא ענה',
          screened: 'סונן',
          error: 'שגיאה'
        },
        facts: {
          agree: 'תואמות',
          partial: 'חלקית',
          conflict: 'סותרות',
          none: 'ללא עובדות'
        },
        usableYes: 'שמישה',
        usableNo: 'לא שמישה',
        judgeNote: 'הערת השופט',
        untraceableList: 'מספרים בטיוטה שאין להם מקור',
        kept: 'הייתה נשארת ב-LCL'
      }
    },
    overview: {
      monthCost: 'עלות החודש',
      todayCost: 'עלות היום',
      cap: 'תקרת עלות יומית',
      noCap: 'ללא תקרה',
      ofCap: 'מתוך תקרה יומית של ${{cap}}',
      connections: "חיבורי צ'אט פעילים",
      connectionCount: '{{count}} חיבורים פעילים',
      mailboxes: '{{count}} תיבות מנוטרות',
      oneMailbox: 'תיבה מנוטרת אחת',
      on: 'פעיל',
      off: 'כבוי',
      dcrOn: 'רישום דינמי פעיל',
      dcrOff: 'רישום דינמי כבוי',
      configured: 'מוגדר',
      noKey: 'חסר מפתח',
      blocked:
        '{{feature}} פועל עם הספק {{provider}}, אבל לספק אין מפתח בשרת. הקריאות למודל ייכשלו.'
    },
    usage: {
      periods: {
        day: 'היום',
        week: 'שבוע',
        month: 'חודש',
        year: 'שנה'
      },
      cost: 'עלות (USD)',
      requests: 'בקשות',
      tokens: 'טוקנים',
      chart: 'עלות יומית',
      byFeature: 'עלות לפי יכולת',
      daily: 'פירוט יומי',
      feature: 'יכולת',
      date: 'תאריך',
      empty: 'אין שימוש ב-AI בתקופה הזו.',
      noAccess: 'אין לך הרשאה לצפות בנתוני העלות.',
      noCostToLcl: "ללא עלות ל-LCL (מודל הצ'אט של המשתמש)",
      features: {
        triage: 'ניתוב מיילים',
        backtest: 'בדיקת דיוק על מיילים מהעבר',
        test: 'בדיקת חיבור למודל',
        ink: 'זיהוי כתב יד',
        chat: "צ'אט על נתוני LCL"
      },
      cap: 'תקרת עלות יומית (דולר)',
      capHint:
        'כשעלות ה-AI של היום (שעון ישראל) מגיעה לתקרה, כל הקריאות למודלים נעצרות עד חצות. 0 = ללא תקרה.'
    },
    mailTriage: {
      settings: 'הגדרות',
      departments: 'מחלקות',
      mailboxes: 'תיבות דואר',
      rules: 'כללי ניתוב',
      categories: 'קטגוריות',
      decisionLog: 'יומן החלטות'
    },
    system: {
      serverTime: 'שעת השרת',
      storage: 'אחסון SharePoint',
      used: 'בשימוש',
      remaining: 'פנוי',
      total: 'סה"כ',
      deleted: 'נמחק',
      state: 'מצב'
    }
  },
  mailTriage: {
    title: 'ניתוב מיילים אוטומטי',
    intro:
      'כל מייל שנכנס לתיבת המשרד מקבל מחלקה ותגיות, עם ההסבר והרשומות ב-LCL שעליהן ההחלטה נשענת. אשרו החלטה נכונה או תקנו שגויה: כך ה-AI לומד.',
    days: 'ימים אחורה',
    stats: {
      inbound: 'מיילים נכנסים',
      decisions: 'החלטות',
      drafts: 'טיוטות שנוצרו',
      lowConfidence: 'ביטחון נמוך',
      injection: 'חשד להנחיות זדוניות',
      cost: 'עלות (דולר)',
      accuracy: 'דיוק מול בחירה אנושית',
      exact: 'התאמה מלאה',
      overlap: 'התאמה חלקית',
      evaluated: 'הוערכו',
      topTags: 'תגיות נפוצות',
      inDays: 'ב-{{days}} הימים האחרונים',
      reviewHint: 'החלטות שמחכות לאדם',
      evaluatedCount: '{{count}} החלטות אושרו או תוקנו',
      noEvaluation: 'אשרו או תקנו החלטות כדי למדוד',
      injectionAlert:
        '{{count}} מיילים עם ניסוחים שנראים כהנחיות למודל נשלחו לבדיקה ידנית.'
    },
    filters: {
      status: 'סטטוס',
      outcome: 'תוצאה',
      all: 'הכל',
      search: 'חיפוש בנושא / שולח',
      department: 'מחלקה',
      state: 'מצב'
    },
    columns: {
      received: 'התקבל',
      from: 'שולח',
      subject: 'נושא',
      suggested: 'הצעת ניתוב',
      department: 'מחלקה',
      confidence: 'ביטחון',
      status: 'סטטוס',
      outcome: 'תוצאה',
      categories: 'קטגוריות',
      state: 'מצב',
      actions: 'פעולות'
    },
    state: {
      review: 'לבדיקה ידנית',
      decided: 'הוחלט',
      confirmed: 'אושר',
      corrected: 'תוקן',
      forwarded: 'הועבר ידנית',
      skipped: 'ללא פעולה',
      error: 'שגיאה'
    },
    categories: {
      lclOnly: 'רק ב-LCL',
      inOutlookShort: 'מופיע ב-Outlook',
      inOutlook: 'מופיע ב-Outlook מ-{{date}}',
      failed: 'רק ב-LCL: הכתיבה ל-Outlook נכשלה, ניסיון נוסף בעוד שעה'
    },
    status: {
      'shadow-decided': 'הוחלט (צל)',
      'draft-pending': 'טיוטה בתהליך',
      'draft-created': 'טיוטה נוצרה',
      'low-confidence': 'ביטחון נמוך',
      skipped: 'ללא פעולה',
      error: 'שגיאה'
    },
    outcome: {
      pending: 'ממתין',
      'sent-as-is': 'נשלח כפי שהוצע',
      'sent-edited': 'נשלח עם שינוי',
      deleted: 'נמחק',
      ignored: 'לא טופל',
      'human-forwarded': 'הועבר ידנית',
      'human-no-forward': 'לא הועבר',
      corrected: 'תוקן ידנית',
      confirmed: 'אושר'
    },
    category: {
      route: 'ניתוב',
      'no-action': 'ללא פעולה',
      'needs-human': 'דורש אדם'
    },
    detail: {
      title: 'פרטי ההחלטה',
      note: 'הערה למשרד',
      reasoning: 'נימוק',
      examples: 'דוגמאות מהעבר שהמודל ראה',
      body: 'תוכן המייל (מנוקה)',
      showBody: 'הצגת תוכן',
      model: 'מודל',
      cost: 'עלות',
      correct: 'תיקון',
      correctHint:
        'בחרו את המחלקה הנכונה ואת התגיות. התיקון נשמר ומשפר את ההחלטות הבאות.',
      confirm: 'נכון',
      confirmHint: 'ההחלטה נכונה: אישור המחלקה',
      cancel: 'ביטול',
      confidence: '{{percent}}% ביטחון',
      forwardedTo: 'הועבר אל',
      technical: 'פרטים טכניים',
      error: 'שגיאה',
      errorAlert:
        'ההחלטה נכשלה. ניסיון חוזר מתבצע אוטומטית; הפרטים ב"פרטים טכניים".',
      tags: 'תגיות',
      actual: 'המחלקה שנבחרה',
      evidence: 'על מה ההחלטה נשענת',
      saveCorrection: 'שמירת תיקון',
      retry: 'הרצה מחדש',
      openInOutlook: 'פתיחה ב-Outlook',
      injectionWarning:
        'המייל מכיל ניסוחים שנראים כהנחיות למודל. הועבר לבדיקה אנושית.'
    },
    empty: 'אין החלטות עדיין. ודאו שתיבת המשרד מנוטרת ושהמצב אינו "כבוי".',
    saved: 'נשמר',
    failed: 'הפעולה נכשלה',
    loadFailed: 'הטעינה נכשלה',
    bodyPurged: '(התוכן נמחק לפי מדיניות השמירה)',
    bodyEmpty: '(ריק)',
    bodyForbidden: 'אין הרשאה לצפייה בתוכן',
    correctionSaved: 'התיקון נשמר',
    confirmed: 'ההחלטה אושרה',
    noDepartment: 'ללא מחלקה',
    evidence: {
      order: 'הזמנה',
      subproject: 'הסכם / הצעת מחיר',
      noBranch: 'ללא ענף',
      keywords: 'מילות מפתח של',
      thread: 'מייל קודם באותו שרשור טופל ב:',
      none: 'לא נמצאו רשומות או מילות מפתח. ההחלטה מבוססת על תוכן המייל.'
    },
    retried: 'ההחלטה חושבה מחדש'
  },
  mcpConsent: {
    title: "חיבור צ'אט ל-LCL",
    howToConnect:
      'כדי להתחבר, הוסיפו את LCL כ-Connector ב-Claude או ב-ChatGPT; העמוד הזה ייפתח עם בקשה לאישור.',
    myConnections: 'החיבורים שלי',
    subtitle: 'האפליקציה הבאה מבקשת גישה לנתוני LCL בשמכם',
    client: 'אפליקציה',
    redirect: 'לאחר האישור תועברו אל',
    scope: 'הרשאות מבוקשות',
    scopes: {
      'lcl:read':
        'קריאת נתוני LCL שאתם רשאים לראות (הזמנות, הסכמים, פרוייקטים, חברות, אנשי קשר, בדיקות)'
    },
    tools: "מה הצ'אט יוכל לעשות",
    readOnly: "הגישה לקריאה בלבד. הצ'אט לא יכול לשנות, למחוק או לשלוח דבר.",
    dataSharing:
      "הנתונים שהצ'אט קורא (כולל מחירים, אם אתם רשאים לראותם) נשלחים לשרתי ספק הצ'אט (Anthropic / OpenAI) לצורך המענה.",
    revokeHint:
      'אפשר לנתק בכל עת מתפריט המשתמש > "החיבורים שלי" (או מהגדרות הבינה המלאכותית, למנהלים).',
    clientIdLabel: 'מזהה לקוח',
    dcrBadge: 'רישום עצמי',
    dcrHint:
      'הלקוח נרשם בעצמו ולא אומת על ידי LCL. ודאו שהשם והכתובת תואמים לאפליקציה שפתחתם.',
    approve: 'אישור וחיבור',
    deny: 'ביטול',
    noPermission: "אין לכם הרשאה לחבר צ'אט ל-LCL. פנו למנהל המערכת.",
    notPending: "הבקשה כבר טופלה או שפג תוקפה. חזרו לצ'אט ונסו שוב.",
    notFound: "הבקשה לא נמצאה. חזרו לצ'אט ונסו שוב.",
    notAllowed: 'אין לכם גישה לבקשה הזו. התחברו עם המשתמש הנכון ונסו שוב.',
    loadFailed: "טעינת הבקשה נכשלה. חזרו לצ'אט ונסו שוב.",
    disabled: "חיבור הצ'אט כבוי במערכת. פנו למנהל המערכת.",
    redirecting: 'מעבירים אתכם חזרה לאפליקציה...',
    failed: 'הפעולה נכשלה'
  },
  schedulingDurations: {
    title: 'זמני בדיקות',
    intro:
      'זמן הבדיקה נקבע לפי סוג הבדיקה והכמות בהזמנה. כמות שאינה מכוסה באף שורה נשלחת ליומן ללא זמן.',
    minutes: 'דקות',
    range: 'טווח',
    upTo: 'עד כמות',
    addBucket: 'הוסף שורה',
    unbounded: 'ללא הגבלה עליונה (כל כמות מעבר לשורה האחרונה)',
    anyQuantity: 'כל כמות',
    willCover: 'השורה תכסה טווח',
    noDuration: 'ללא זמן — לא יישלח',
    noBuckets: 'לא הוגדרו זמנים — לא יישלח זמן',
    save: 'שמור',
    cancel: 'בטל',
    edit: 'ערוך',
    delete: 'מחק',
    deleteConfirm: 'בטוח/ה שברצונך למחוק?'
  },
  misc: 'שונות',
  username: 'שם משתמש',
  type: 'סוג',
  partType: 'סוג הרכיב',
  model: 'דגם',
  manufacture: 'תוצרת',
  totalItems: 'כמות',
  inspectionId: `מס' צ'ק ליסט`,
  icountOrderUpdatedAt: 'תאריך הפקת חשבונית',
  inspectionScheduledAt: 'תואמה בדיקה לתאריך',
  movedToPlansInspectionAt: 'הועבר לבדיקת תכניות בתאריך',
  isMarked: 'מסומן כחריג',
  canApproveInspections: 'רשאי לחתום על תעודה',
  link: 'קישור',
  inspectionPrintPreview: `הדפסת צ'קליסט`,
  area: 'איזור',
  true: 'כן',
  false: 'לא',
  description: 'תאור',
  city: {
    name: 'עיר',
    area: 'איזור'
  },
  subProject: {
    name: 'שם הפרוייקט'
  },
  company: {
    name: 'שם החברה',
    companyNumber: 'ח.פ.',
    status: {
      name: 'סטטוס חברה'
    }
  },
  planner: {
    name: 'שם המתכנן'
  },
  contractor: {
    name: 'שם הקבלן'
  },
  inspectionField: {
    name: 'תחום'
  },
  status: {
    name: 'סטטוס'
  },
  sections: {
    [Path.Projects]: 'פרוייקטים',
    [Path.Subprojects]: 'הסכמים',
    [Path.Orders]: 'הזמנות',
    [Path.Companies]: 'חברות',
    [Path.Planners]: 'מתכננים',
    [Path.Contractors]: 'קבלנים',
    [Path.Contacts]: 'אנשי קשר',
    [Path.Users]: 'משתמשים',
    [Path.Stats]: 'סטטיסטיקה',
    [Path.Reminders]: 'תזכורות',
    [Path.History]: 'הסטוריה',
    [Path.InspectionsBank]: 'סוגי בדיקות',
    [Path.FireAlarmComponents]: 'רכיבי מערכת',
    [Path.Cities]: 'רשימת ערים ומיקומים',
    [Path.InspectionTemplates]: `רשימת תבניות צ'קליסט`,
    [Path.Permissions]: 'תפקידים והרשאות',
    [Path.SchedulingDurations]: 'זמני בדיקות',
    [Path.AiSettings]: 'הגדרות AI',
    [Path.SuperAdmin]: 'ניהול מערכת',
    [Path.MailTriage]: 'ניתוב מיילים (AI)'
  },
  section: {
    [Path.Projects]: 'פרוייקט',
    [Path.Subprojects]: 'הסכם',
    [Path.Orders]: 'הזמנה',
    [Path.Companies]: 'חברה',
    [Path.Planners]: 'מתכנן',
    [Path.Contractors]: 'קבלן',
    [Path.Contacts]: 'איש קשר',
    [Path.Users]: 'משתמש',
    [Path.Reminders]: 'התראה',
    [Path.Stats]: 'סטטיסטיקה',
    [Path.InspectionsBank]: 'סוג בדיקה',
    [Path.History]: 'הסטוריה',
    [Path.FireAlarmComponents]: 'רכיב',
    [Path.InspectionTemplates]: `רשימת תבניות צ'קליסט`
  },
  entity: {
    Project: 'פרוייקט',
    Subprojects: 'הסכם',
    Order: 'הזמנה',
    Company: 'חברה'
  },
  orderState: {
    waitingForInspection: 'ממתין לבדיקה',
    inspectionInProgress: 'בבדיקה',
    office: 'בטיפול',
    done: 'סיום ביצוע'
  },
  range: {
    week: 'שבוע',
    month: 'חודש',
    year: 'שנה'
  },
  search: {
    title: 'חיפוש גלובלי',
    search: 'חיפוש',
    searchData: 'נתוני חיפוש',
    allSelectOption: 'כל הקטגוריות',
    selectedOptions: 'קטגוריות',
    searchResult: 'תוצאות חיפוש',
    errorMessage: {
      minLength: 'יש להקליד לפחות {{value}} תוים',
      optionsNotSelected: 'בחר קטגוריה'
    }
  },
  filter: {
    filters: 'פילטרים',
    filterValue: 'חיפוש',
    booleanFilters: {
      isActive: {
        true: 'פעיל',
        false: 'לא פעיל'
      },
      isPrivate: {
        true: 'פרטי',
        false: 'פומבי'
      },
      isMarked: {
        true: 'כן',
        false: 'לא'
      }
    }
  },
  button: {
    cancel: 'ביטול',
    save: 'שמירה',
    ok: 'אישור',
    add: 'הוספה',
    delete: 'מחיקה',
    edit: 'עריכה',
    select: 'בחר',
    remove: 'הסרה',
    apply: 'אישור',
    reset: 'איפוס',
    clear: 'נקה',
    close: 'סגור',
    upload: 'העלה',
    entrance: 'כניסה',
    back: 'חזור',
    muteAll: 'להשתיק את הכול',
    unmuteAll: 'להחזיר הכל',
    putOff: 'לדחות',
    addItem: 'הוסף {{item}}',
    seeAll: 'ראה הכל...',
    username: 'שם משתמש'
  },
  contactDialog: {
    add: 'הוספת איש קשר',
    edit: 'עריכת איש קשר'
  },
  error: {
    emailRequired: 'אימייל זה שדה חובה',
    email: 'הכנס/י אימייל תקין',
    plannerName: 'הכנס שם מתכנן',
    cityName: 'הכנס עיר או שם של מקום',
    unknownErr: 'משהו השתבש',
    minLength: 'אורך מינימלי {{numb}} תווים',
    [ErrorEnum.UserNotFound]: 'User not found',
    [ErrorEnum.NotAccepted]: 'Username or Password not accepted',
    [ErrorEnum.PasswordChangeRequired]: 'User not found',
    [ErrorEnum.TokenExpired]: 'Token expired',
    forbidden: 'Forbidden. Please try again',
    required: 'זהו שדה חובה',
    openChecklist: `לא ניתן לפתוח צ'ק ליסט`,
    saveOrderBeforeChecklist: `יש לשמור את השינויים בהזמנה לפני פתיחת צ'ק ליסט`
  },
  fileStorage: {
    title: 'קבצים',
    upload: 'העלאת קבצים',
    uploadTo: 'העלה ל{{value}}',
    uploaded: 'העלאת קבצים הסתיימה',
    uploading: 'מעלה {{progressNumb}} קבצים...',
    uploadFailed: 'נכשלו {{failed}} מתוך {{length}}',
    dragAndDropDescription: 'לחץ או גרור קבצים לאזור זה להעלאה',
    filters: {
      tooBigFile: 'גודל הקובץ {{name}} גדול מדי'
    },
    queue: {
      folder: 'תיקיה',
      file: 'קובץ',
      fileSize: 'גודל הקובץ',
      filename: 'שם',
      object: 'יעד'
    },
    messages: {
      cancelled: 'ההעלאה בוטלה',
      error: 'העלאת הקובץ נכשלה'
    },
    uploadZone: {
      subProjects: 'הסכמים',
      orders: 'הזמנות',
      general: 'מסמכים כלליים',
      bookKeeping: 'הנהלת חשבונות',
      plans: 'תוכניות',
      plansDir: 'תוכניות',
      bookKeepingDir: 'הנהלת חשבונות',
      temporary: 'קבצים לפיזור',
      checkList: 'תמונות מהשטח',
      userAvatars: 'תמונות פרופיל',
      userSignatures: 'חתימות',
      certificats: 'תעודות'
    }
  },
  users: {
    // auto filling from UsersService
    // name: hebrewName
  },
  menu: {
    openStorage: 'פתח תיקייה',
    upload: 'העלאת קבצים',
    delete: 'מחק',
    checklist: 'צ׳ק ליסט'
  },
  login: {
    login: 'שם משתמש',
    password: 'ססמא',
    changePassword: {
      oldPassword: 'סיסמה ישנה',
      newPassword: 'סיסמה חדשה',
      repeatPassword: 'חזור על הסיסמה',
      repeatPasswordFailed: 'הסיסמה הראשונה אינה תואמת את השנייה',
      change: 'שינוי סיסמא',
      changeAndEnter: 'שנה סיסמה והתחבר'
    },
    error: 'שם משתמש או הססמא אינם נכונים',
    superseded: 'ההתחברות נקטעה עקב שינוי בחשבון. נסה שוב',
    passwordChanged: 'הסיסמה שונתה. התחבר עם הסיסמה החדשה',
    recoverPassword: 'שכחתי סיסמה',
    or: 'או',
    signInWithMicrosoft: 'התחבר עם Microsoft',
    microsoftError: {
      user_not_found: 'לא נמצא משתמש עם כתובת האימייל הזו',
      auth_failed: 'ההתחברות עם Microsoft נכשלה',
      microsoft_auth_failed: 'ההתחברות עם Microsoft נכשלה',
      no_auth_code: 'ההתחברות עם Microsoft נכשלה',
      account_disabled: 'החשבון מושבת. פנה למנהל המערכת',
      invalid_state: 'פג תוקף ההתחברות עם Microsoft. נסה שוב',
      missing_code_challenge: 'ההתחברות עם Microsoft נכשלה',
      invalid_code_challenge: 'ההתחברות עם Microsoft נכשלה',
      login_superseded: 'ההתחברות נקטעה עקב שינוי בחשבון. נסה שוב'
    },
    message: {
      emailWasSent: 'דוא"ל נשלח אליך עם הוראות',
      changedSuccessfully: 'סיסמה שונתה בהצלחה',
      passChangeFailed: 'שינוי הסיסמה נכשל',
      wrongPassword: 'הסיסמה אינה נכונה',
      tokenExpired: 'הקישור פג. בבקשה נסה שוב'
    }
  },
  form: {
    personalData: 'פרטיים אישיים',
    userData: 'פרטי משתמש',
    required: 'שדה נדרש'
  },
  userProfile: {
    logout: 'יציאה מהמערכת',
    viewProfile: 'פרופיל',
    reminders: 'תזכורות',
    myConnections: 'החיבורים שלי'
  },
  userRoles: {
    'super-admin': 'סופר מנהל',
    admin: 'מנהל',
    office: 'משרד',
    tester: 'בודק',
    'senior-tester': 'בודק בכיר',
    guest: 'אורח'
  },
  appVersion: {
    title: 'גרסה חדשה של המערכת זמינה',
    content:
      'יש לרענן את הדף כדי לעבוד עם הגרסה החדשה. שינויים בבדיקה שלא נשמרו יוצעו לטעינה מחדש לאחר הרענון.',
    reload: 'רענן עכשיו',
    later: 'הזכר לי בעוד {{minutes}} דקות'
  },
  notice: {
    reminder: 'תזכורת',
    private: 'פרטיות',
    public: 'פומביות',
    isActive: 'מצב',
    privacy: 'סוג',
    title: 'כותרת',
    all: 'כל התזכורות',
    putOff: '{{numb}} דקות',
    putOffMessage: 'התזכורת נדחתה ב-{{min}} דקות',
    notFound: 'אין תזכורות',
    newReminderForm: {
      titleAdd: 'הוספת תזכורת',
      titleEdit: 'עריכת תזכורת',
      reminderTitle: 'כותרת',
      date: 'תאריך',
      note: 'הערה',
      recipient: 'מטופל ע"י'
    },
    notificationList: {
      title: 'תזכורות',
      createdBy: 'על ידי {{username}}',
      createdOn: 'נוצר ב {{date}}',
      all: 'מתוזמנות',
      today: 'היום',
      missed: 'הוחמצו'
    }
  },
  dialogs: {
    confirm: {
      exit: {
        title: 'שינויים לא נשמרו',
        content: 'בוצעו שינויים שלא נשמרו. האם את/ה בטוח שברצונך להמשיך?'
      }
    }
  },
  composeEmail: {
    to: 'אל',
    from: 'מאת',
    subject: 'נושא',
    content: 'תוכן'
  },
  inspection: {
    sections: {
      general: 'נתונים כלליים',
      generalNotes: 'הערות כלליות',
      summary: 'סיכום',
      summaryCertificateNotes: 'הערות סיכום לתעודה',
      conflictOfInterest: 'הצהרת משוא פנים',
      installation: 'בדיקת התקנה',
      alarms: 'בדיקת גלאים',
      waterFlow: 'ספיקה ולחצים',
      design: 'בדיקת תכניות',
      gasExtinguishing: 'מערכת כיבוי גז',
      aerosolShutdown: 'מערכת כיבוי אירוסול',
      fireAlarmSystem: 'מערכת גילוי אש',
      plans: 'נתוני התוכניות',
      waterNetwork: 'בדיקת אופיין רשת מים',
      inspectionWaterNetworkCharacterization: 'בדיקת אופיין רשת מים',
      inspectionDesign: 'בדיקת תכניות',
      inspectionInstallation: 'בדיקת התקנה',
      inspectionFireAlarmSystem: 'מערכת גילוי אש',
      inspectionGasExtinguishingSystem: 'מערכת כיבוי גז',
      inspectionAerosolShutdown: 'מערכת כיבוי אירוסול',
      inspectionFireTaps: 'ברזי כיבוי אש',
      inspectionFireExtinguishers: 'מטפי כיבוי אש',
      inspectionAirConditioningAndVentilationSystems: 'מיזוג אוויר ואוורור',
      inspectionVentilationSystemAndFireProtection: 'מערכת אוורור והגנה מאש',
      inspectionPressureSystemInStairwellsCompatibilityCheck:
        'מערכת לחץ בחדרי מדרגות',
      inspectionIntegration: 'אינטגרציה'
    } as Record<string, string>,
    fields: {
      // General section
      'general:inspectionDate': 'תאריך הבדיקה',
      'general:representativeName': 'נציג המזמין שהיה נוכח בעת הבדיקה',
      'general:inspectionType': 'סוג הבדיקה',
      'general:fireExtinguishingType': 'מערכת לכיבוי אש באמצעות',
      'general:standard': 'מהות הבדיקה',
      'general:standardExtraText': 'מהות הבדיקה מלל חופשי',
      'general:standardExtraTextPlaceholder': 'מהות הבדיקה מלל חופשי...',
      'general:inspectionCount': 'מניין בדיקות',
      'general:inspectionCountPlaceholder': 'בדיקה ראשונה של...',
      'general:disclaimerSignature': 'חתימה:',
      'general:inspectorName': 'שם הבודק:',
      'general:inspectionDatePerformed': 'תאריך ביצוע הבדיקה:',
      // Disclaimer
      'disclaimer:conflictQuestion':
        'האם אתה מכיר עובד/יועץ/קבלני משנה השותפים בפרויקט?',
      'disclaimer:biasQuestion': 'האם יש סיבה למשוא פנים?',
      'disclaimer:addNote': 'הוסף הערה',
      'disclaimer:paragraph1':
        'במידה ובמהלך הבדיקה קיים משוא פנים אני מתחייב להודיע להנהלת החברה במיידי.',
      'disclaimer:paragraph2':
        'הריני לאשר בזאת כי כלל המסמכים שהתקבלו מהלקוח נסקרו על ידי ונראים שלמים (במבחן האדם הסביר) כמידע ממקור אמין.',
      'disclaimer:paragraph3':
        'הערה:הנושאים הנבחנים הינם:המסמכים חתומים, המסמך נראה שלם, אם בוצעו בדיקות ע"י מעבדות חיצוניות ,מעבדות אלו הוסמכו לבדיקה זו ע"י הרשות להסמכת מעבדות ( למעט מכון התקנים) ,קיימת עמידה בדרישות התקן (או לחילופין נרשמה הערה על כך) וכדומה.',
      // Installation section
      'installation:companion': 'הבדיקה נערכה בליווי',
      'installation:companionPlaceholder': 'שם מלווה',
      // Alarms section
      'alarms:hubLocation': 'מיקום הרכזת',
      'alarms:hubModel': 'דגם הרכזת',
      'alarms:serialNumber': "מס' סידורי",
      'alarms:dialer': 'חייגן',
      'alarms:accessoryType': 'סוג האביזר',
      'alarms:locationNickname': 'מיקום (כינוי)',
      'alarms:accessoryAddress': 'כתובת האביזר',
      'alarms:attachToCertificate': 'צרף לתעודה',
      'alarms:suitable': 'מתאים',
      'alarms:notSuitable': 'לא מתאים',
      // Water flow section
      'waterFlow:flowRateGPM': 'ספיקה GPM',
      'waterFlow:declaredPressurePSI': 'לחץ מוצהר PSI',
      'waterFlow:measuredPressurePSI': 'לחץ מדוד PSI',
      'waterFlow:rotationSpeed': 'מהירות סיבוב',
      'waterFlow:noFlow': 'ללא זרימה',
      'waterFlow:hundredPercent': '100%',
      'waterFlow:hundredFiftyPercent': '150%',
      'waterFlow:closedTap:declaredPressure': 'ללא זרימה - לחץ מוצהר',
      'waterFlow:closedTap:measuredPressure': 'ללא זרימה - לחץ מדוד',
      'waterFlow:closedTap:rotationSpeed': 'ללא זרימה - מהירות סיבוב',
      'waterFlow:100:flowRate': '100% - ספיקה',
      'waterFlow:100:declaredPressure': '100% - לחץ מוצהר',
      'waterFlow:100:measuredPressure': '100% - לחץ מדוד',
      'waterFlow:100:rotationSpeed': '100% - מהירות סיבוב',
      'waterFlow:150:flowRate': '150% - ספיקה',
      'waterFlow:150:declaredPressure': '150% - לחץ מוצהר',
      'waterFlow:150:measuredPressure': '150% - לחץ מדוד',
      'waterFlow:150:rotationSpeed': '150% - מהירות סיבוב',
      // Plan columns (used across design, gasExtinguishing, aerosolShutdown, fireAlarmSystem)
      'plans:name': 'שם התוכנית',
      'plans:identificationCode': 'קוד זיהוי',
      'plans:edition': 'מהדורה',
      'plans:date': 'תאריך',
      'plans:notes': 'הערות',
      'plans:file': 'קובץ',
      'plans:addPlan': 'הוסף תוכנית',
      'plans:addPlansFromFiles': 'הוסף תוכניות מקבצים',
      'plans:attachFileFromList': 'צרף קובץ מרשימה',
      'plans:uploadNewFile': 'העלאת קובץ חדש',
      'plans:remove': 'הסר',
      // Shared case conclusion labels
      'case:suitable': 'מתאים',
      'case:notSuitable': 'לא מתאים',
      'case:notApplicable': 'לא ישים',
      // Shared notes labels
      'case:note': 'הערה',
      'case:notesLabel': 'הערות:',
      'case:addNote': 'הוסף',
      'case:confirm': 'אישור',
      'case:accept': 'קבל',
      'case:cancel': 'בטל',
      'case:attachToCertificate': 'צרף לתעודה',
      'case:rewriteWithAI': 'שכתב טקסט באמצעות AI',
      'case:undoRewrite': 'בטל שכתוב',
      'case:clearDrawing': 'נקה ציור',
      'case:clear': 'נקה',
      'case:aiRewriteError': 'שגיאה בשכתוב הטקסט',
      // Dial risk section
      'dialRisk:dialerPhoneNumber': 'מספר טלפון של החייגן',
      'dialRisk:dialerTargetPhone': 'מספר הטלפון אליו מחייג החייגן',
      'dialRisk:messageRecipientName': 'שם מקבל ההודעה',
      'dialRisk:dialerCheckTime': 'שעת בדיקת החייגן',
      'dialRisk:report': 'דיווח',
      // Risk levels section
      'riskLevels:riskLevel': 'רמת סיכון',
      'riskLevels:markCheck': 'סמן ✔',
      'riskLevels:installationAreas': 'אזורי ההתקנה',
      // Preaction system
      'preactionSystem:systemType': 'סוג מערכת',
      // Shutdown pump
      'shutdownPump:test': 'בדיקה',
      'shutdownPump:addTest': 'הוסף בדיקה',
      // Water network characterization
      'waterNetwork:testerName': 'שם הבודק',
      'waterNetwork:testDateTime': 'שעת הבדיקה',
      'waterNetwork:pressureMeasurementLocation': 'מיקום מדידת לחצים',
      'waterNetwork:flowMeasurementLocation': 'מיקום מדידת ספיקות',
      'waterNetwork:waterSupplyPipeDiameter': 'קוטר צינור אספקת המים',
      'waterNetwork:staticPressure': 'לחץ סטטי',
      'waterNetwork:residualPressure': 'לחץ שיורי',
      'waterNetwork:flowRate': 'ספיקה נמדדת',
      'waterNetwork:systemFlow': 'ספיקה מחושבת',
      'waterNetwork:systemDemand': 'לחץ מחושב',
      'waterNetwork:type': 'בדיקת אופין רשת מים',
      'waterNetwork:syncStats': 'משוך לחץ וספיקה מתכנון',
      'waterNetwork:showChart': 'הצג גרף',
      'waterNetwork:test': 'בדיקה',
      'waterNetwork:addTest': 'הוסף בדיקה',
      // Dynamic field suffixes (used by sub-components with dynamic fieldSection:title:suffix IDs)
      pressure: 'לחץ',
      staticPressure: 'לחץ סטטי',
      residualPressure: 'לחץ שיורי',
      nominalPressure: 'לחץ נומינלי',
      flowRate: 'ספיקה',
      declaredPressure: 'לחץ מוצהר',
      measuredPressure: 'לחץ מדוד',
      rotationSpeed: 'מהירות סיבוב',
      poolingVolume: 'נפח',
      wfpPressure: 'דרישת מים (לחץ)',
      wfpFlowRate: 'דרישת מים (ספיקה)',
      percentage: 'ריכוז הקצף',
      zCoefficient: 'Z מקדם',
      length: 'אורך',
      width: 'רוחב',
      depth: 'עומק',
      volume: 'נפח',
      time: 'זמן',
      value: 'ערך',
      dialNumber: 'מספר טלפון של החייגן',
      checkTime: 'שעת בדיקת החייגן',
      phone: 'מספר טלפון',
      name: 'שם'
    } as Record<string, string>,
    actions: {
      resetData: 'אפס נתונים',
      pullData: 'משיכת נתונים',
      pullFromOrders: 'משוך נתונים מהזמנות קודמות',
      pullFromTemplate: 'משוך נתונים מתבנית',
      saveAsTemplate: 'שמור כתבנית',
      certificate: 'תעודה',
      draft: 'טיוטה',
      importFromDraft: 'ייבוא מטיוטה'
    } as Record<string, string>
  }
};
